import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getPersonList,
	addNewPerson,
	updatePerson,
	deletePerson,
	getPerson,
	importPerson,
} from '../person/thunk';

export const initialState = {
	itemPersonList: [],
	itemPersonDetail: null,
	isPersonLoading: false,
	isPersonSuccess: false,

	personList: [],
	personListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const PersonSlice = createSlice({
	name: 'Persons',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getPerson.fulfilled, (state, action) => {
			state.isPersonLoading = false;
			state.isPersonSuccess = true;
			state.itemPersonDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getPerson.pending, state => {
			state.isPersonLoading = true;
			state.isPersonSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getPerson.rejected, (state, action) => {
			state.isPersonLoading = false;
			state.isPersonSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getPersonList.pending, state => {
			state.isPersonSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getPersonList.fulfilled, (state, action) => {
			state.itemPersonList = action.payload;
			state.personList = action.payload;
			state.isLoadingList = false;
			state.isPersonSuccess = true;

			let personListSelect = [];
			action.payload.map(item =>
				personListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.personListSelect = personListSelect;
		});
		builder.addCase(getPersonList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isPersonSuccess = true;
		});

		
		builder.addCase(addNewPerson.fulfilled, (state, action) => {
			state.itemPersonList.push(action.payload);
			state.personList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewPerson.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewPerson.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});


		
		// builder.addCase(setPersonCancelled.fulfilled, (state, action) => {
		// 	state.itemPersonList.push(action.payload);
		// 	state.personList.push(action.payload);			
		// 	state.isPersonSuccess = true;
		// 	state.requireCloseModal = true;
		// 	state.isLoadingList = false;
		// });
		// builder.addCase(setPersonCancelled.pending, (state, action) => {
		// 	state.isPersonSuccess = null;
		// 	state.isLoadingList = true;
		// });
		// builder.addCase(setPersonCancelled.rejected, (state, action) => {
		// 	state.error = action.payload || null;
		// 	state.isLoadingList = false;		
		// 	state.isPersonSuccess = false;
		// });



		builder.addCase(updatePerson.fulfilled, (state, action) => {
			state.itemPersonList = state.itemPersonList.map(person =>
				person.personname === action.payload.old_person
					? { ...person, ...action.payload.updated_person }
					: person
			);
			state.personList = state.personList.map(person =>
				person._id.toString() === action.payload._id.toString()
					? { ...person, ...action.payload }
					: person
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updatePerson.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updatePerson.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deletePerson.fulfilled, (state, action) => {
			state.itemPersonList = current(state.itemPersonList).filter(
				item => item._id !== action.payload._id
			);
			state.personList = current(state.personList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deletePerson.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deletePerson.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});

		

		
		builder.addCase(importPerson.fulfilled, (state, action) => {
			state.isPersonLoading = false;
			state.isPersonSuccess = true;
			state.itemPersonDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(importPerson.pending, state => {
			state.isPersonLoading = true;
			state.isPersonSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(importPerson.rejected, (state, action) => {
			state.isPersonLoading = false;
			state.isPersonSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});
	},
});

export const { setRequireCloseModal } = PersonSlice.actions;

export default PersonSlice.reducer;
